module.exports = __webpack_public_path__ + "static/media/logotype-slogan.e902cb1d.svg";